import script from "./BtnCont.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnCont.vue?vue&type=script&setup=true&lang=js"

import "./BtnCont.vue?vue&type=style&index=0&id=4c5688c5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5688c5"]])

export default __exports__